import React, { useState, useEffect } from 'react';
import CommonSelect from '../../../components/Dashboard-res/CommonComponent/CommonSelect';
import { useFormikContext } from 'formik';
import selectAdd_01 from '../../../images/icons/SENP/selectAdd_01.svg';
import Styles from './companyDetails.module.css';
import get from 'lodash/get';
import ShopAndEstablisment from './AddressProofContainer/ShopAndEstablisment';
import UserElectricityBill from './BusinessAddress/ElectricityBill';
import RentalAggrement from './BusinessAddress/RentalAgreement';
import LPG from './BusinessAddress/LPG';
import PNG from './BusinessAddress/PNG';

const { select_address } = Styles;

const comonSelectContainerEffect = {
  height: '52px',
  marginBottom: '0px',
  fontSize: '40px'
};
const commonDropDownStles = {
  top: '52px',
  color: 'rgba(0,0,0,0.87)',
  fontSize: '16px',
  backgroundColor: '#fff',
  alignItems: 'center',
  fontFamily: 'Roboto',
  fontWeight: 400
};

const selectCommonDisplay = {
  fontSize: '14px',
  padding: '0 25px'
};

const optionList = [
  {
    value: 'Shop & establishment',
    label: 'Shop & establishment'
  },
  {
    value: 'Utility Bill',
    label: 'Utility Bill'
  },
  {
    value: 'Rental agreement',
    label: 'Rental agreement'
  }
];
const UtilityOption = [
  {
    value: 'Electricity Bill',
    label: 'Electricity Bill'
  },
  {
    value: 'LPG',
    label: 'LPG'
  },
  {
    value: 'PNG',
    label: 'PNG'
  }
];

const BusinessAddressProof = () => {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue,
    setFieldTouched,
    setFieldError,
    validateForm
  } = useFormikContext();
  const [isAddressProofSelected, setAddressProofSelected] = useState(false);
  const [preValues, setPreValues] = useState(values.preValues());

  const ResetAddressProofSelector = () => {
    setAddressProofSelected(false);
    setFieldValue('add_proof', { value: '', label: 'Address Proof' });
  };

  useEffect(() => {
    if (preValues?.companyAddress?.currentAddress == 'yes') {
      handleSubmit();
    }
  }, []);
  return (
    <div className="md:w-full w-11/12 mx-auto  mt-6 bg-blue-1200 md:bg-white lg:px-20  px-6 bg-white py-10 md:py-0 rounded shadow-md md:shadow-none ">
      {!isAddressProofSelected ? (
        <div className="w-full">
          <div className="font-roboto font-medium text-black-850 text-base mb-4 ">
            Select any 1 Business Address Proof
          </div>
          <div className={`md:w-5/12 w-full ${select_address}`}>
            <CommonSelect sort={true}
              name="add_proof"
              value={values.add_proof}
              onChange={e => {
                setFieldValue('add_proof', { value: e.value, label: e.label });
                if (e.label != 'Utility Bill') {
                  setAddressProofSelected(true);
                }
              }}
              options={optionList}
              isHoverEffect
              stylesContainer={comonSelectContainerEffect}
              dropdownStyle={commonDropDownStles}
              styleText={selectCommonDisplay}
              error={touched.add_proof && get(errors, 'add_proof.value', false)}
              touched={touched.add_proof}
            />
          </div>
          {values.add_proof.label == 'Utility Bill' ? (
            <div className={`md:w-5/12 w-full my-4 ${select_address}`}>
              <CommonSelect sort={true}
                name="utilityBIll"
                value={values.utilityBIll}
                onChange={e => {
                  setFieldValue('utilityBIll', {
                    value: e.value,
                    label: e.label
                  });
                  setAddressProofSelected(true);
                }}
                options={UtilityOption}
                isHoverEffect
                stylesContainer={comonSelectContainerEffect}
                dropdownStyle={commonDropDownStles}
                styleText={selectCommonDisplay}
                error={
                  touched.utilityBIll && get(errors, 'utilityBIll.value', false)
                }
                touched={touched.utilityBIll}
              />
            </div>
          ) : null}

          <div className="w-full text-center mx-auto px-2 hidden md:block mt-32 ">
            <img className="mx-auto" src={selectAdd_01} alt="img-01" />
            <p className="font-roboto font-normal text-xs text-grey-2231">
              Please select any address proof to process forward
            </p>
          </div>
        </div>
      ) : (
        <div className="w-full flex my-8">
          <p className="mr-auto font-roboto font-medium base-sm text-black-400">
            {values.add_proof.label}
          </p>
          <p
            className="ml-auto font-roboto font-medium base-sm text-green-1000 cursor-pointer"
            onClick={ResetAddressProofSelector}
          >
            Change Address Proof
          </p>
        </div>
      )}

      <div className="">
        {values.add_proof.label == 'Shop & establishment' ? (
          <ShopAndEstablisment handleSubmit={handleSubmit} />
        ) : null}
        {values.add_proof.label == 'Utility Bill' &&
        values.utilityBIll.label == 'Electricity Bill' ? (
          <UserElectricityBill handleSubmit={handleSubmit} />
        ) : null}
        {values.add_proof.label == 'Utility Bill' &&
        values.utilityBIll.label == 'LPG' ? (
          <LPG handleSubmit={handleSubmit} />
        ) : null}
        {values.add_proof.label == 'Utility Bill' &&
        values.utilityBIll.label == 'PNG' ? (
          <PNG handleSubmit={handleSubmit} />
        ) : null}

        {values.add_proof.label == 'Rental agreement' ? (
          <div className="w-full">
            <RentalAggrement handleSubmit={handleSubmit} />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default BusinessAddressProof;
